/* eslint-disable react/no-danger */
import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "../../css/articlecard.scss";

const truncString = (str, max, add) => {
  const valAdd = add || "...";
  return typeof str === "string" && str.length > max
    ? str.substring(0, max) + valAdd
    : str;
};

const ArticleCard = ({ article, image }) => {
  const ref = useRef(null);
  const [url, setUrl] = useState("unset");

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    const callback = (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const newImage = image;
          setUrl(newImage);
          obs.unobserve(ref.current);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [image]);

  return (
    <div
      ref={ref}
      className="article-card"
      style={{ backgroundImage: `url(${url})` }}
    >
      <div className="article-contents">
        <h1>{article.title}</h1>
        <p>{truncString(article.description, 120, " ...")}</p>
        <Link to={`${article.slug}`}>
          <button
            type="button"
            className="article-card-button"
            title={article.slug}
          >
            Read Article
          </button>
        </Link>
      </div>
    </div>
  );
};

ArticleCard.propTypes = {
  image: PropTypes.string.isRequired,
  article: PropTypes.shape({
    description: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    feature: PropTypes.string.isRequired,
  }).isRequired,
};

export default ArticleCard;
